import React from 'react'
import { Alert, Card, CardBody, Col, Row } from 'reactstrap';
import { Checkbox, Select, Textarea } from "react-inputs-validation";
import { expresionesRegulares } from '../../constants';
import { min } from 'date-fns';

const Recargos = ({
    aplicaRecargos,
    aplicaObservaciones,
    mensajeRecargos,
    requiereRecargos,
    setRequiereRecargos,
    requiereObservacion,
    setRequiereObservacion,
    recargoSeleccionado,
    setRecargoSeleccionado,
    recargos,
    setRecargoModificado,
    mensajeObservaciones,
    observacion,
    setObservacion,
    setObservacionValida,
    mensajeObservacion,
    requiereObservacionObligatoria
}) => {
    return (
        <Card>
            <CardBody>
                {aplicaRecargos &&
                    <React.Fragment>
                        <Row>
                            <Col md={8}>
                                <h5 style={{ fontWeight: "bold" }}>
                                    {mensajeRecargos}
                                </h5>
                            </Col>
                            <Col md={4}>
                                <Row>

                                    <Col md={12}>
                                        <Checkbox
                                            id={"recargos"} // Optional.[String].Default: "".  Input ID.
                                            name={"recargos"} // Optional.[String].Default: "". Input name
                                            classNameInputBox={'check-uber-light'}
                                            value={requiereRecargos} // Required.[String].Default: "".
                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            checked={requiereRecargos} // Required.[Bool].Default: false.
                                            onChange={(requiereRecargos, e) => {

                                                setRequiereRecargos(requiereRecargos)

                                                if (recargoSeleccionado != 0) {
                                                    setRecargoModificado(true)
                                                    setRecargoSeleccionado(0)
                                                }

                                                //console.log(e);
                                            }} // Required.[Func].Default: () => {}. Will return the value.
                                            validationOption={{
                                                name: "recargos", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                                check: false, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            }}
                                        />
                                    </Col>

                                    {requiereRecargos &&
                                        <React.Fragment>
                                            <Col md={12}>
                                                <Select
                                                    tabIndex="6"
                                                    id={"recargos"}
                                                    name={"recargos"}
                                                    value={recargoSeleccionado}
                                                    optionList={recargos}
                                                    onChange={(selec, e) => {
                                                        setRecargoSeleccionado(selec)
                                                        setRecargoModificado(true)
                                                    }}
                                                    validate={false}
                                                    onBlur={() => { }}
                                                    customStyleOptionListContainer={{}}
                                                    validationOption={{
                                                        name: "recargos",
                                                        check: false,
                                                        required: false,
                                                    }}
                                                />
                                            </Col>
                                        </React.Fragment>
                                    }


                                </Row>
                                <Row>


                                </Row>

                            </Col>
                        </Row>

                    </React.Fragment>
                }
                {aplicaObservaciones &&
                    <React.Fragment>
                        <Row>
                            <Col md={10}>
                                <h5 style={{ fontWeight: "bold" }}>
                                    {mensajeObservaciones}
                                </h5>
                            </Col>

                            {
                                !requiereObservacionObligatoria && (
                                    <Col md={1}>

                                        <Row>

                                            <Col md={12}>
                                                <Checkbox
                                                    id={"observacion"} // Optional.[String].Default: "".  Input ID.
                                                    name={"observacion"} // Optional.[String].Default: "". Input name
                                                    classNameInputBox={'check-uber-light'}
                                                    value={requiereObservacion} // Required.[String].Default: "".
                                                    onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                    checked={requiereObservacion} // Required.[Bool].Default: false.
                                                    onChange={(requiereObservacion, e) => {

                                                        setRequiereObservacion(requiereObservacion)

                                                        if (!requiereObservacion) {
                                                            setObservacion('')
                                                        }



                                                        //console.log(e);
                                                    }} // Required.[Func].Default: () => {}. Will return the value.
                                                    validationOption={{
                                                        name: "observacion", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                                        check: false, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                        required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                    }}
                                                />
                                            </Col>


                                        </Row>


                                    </Col>
                                )
                            }

                            {(requiereObservacion || requiereObservacionObligatoria) &&
                                <React.Fragment>
                                    <Col md={12}>
                                        <Alert
                                            color="info"
                                            isOpen={requiereObservacion || requiereObservacionObligatoria}

                                        >
                                            <center>
                                                <p>
                                                    {
                                                        requiereObservacionObligatoria 
                                                            ? mensajeObservacion + ' campo obligatorio' 
                                                            : mensajeObservacion
                                                    }
                                                </p>
                                            </center>
                                        </Alert>
                                    </Col>
                                    <Col md={12}>
                                        <Textarea
                                            rows={6}
                                            type="input"
                                            value={observacion}
                                            validate={true}
                                            name={'observacion'}
                                            id={'observacion'}
                                            classNameInput={"form-control"}
                                            onChange={(value, e) => {
                                                setObservacion(value)
                                            }}
                                            validationCallback={res => {
                                                console.log('resssss', res)
                                                setObservacionValida(!res)

                                            }}
                                            placeholder={'Ingrese una observación'} // Optional.[String].Default: "".

                                            onBlur={e => {

                                            }}
                                            validationOption={{
                                                // required: (requiereObservacion || requiereObservacionObligatoria), // Optional.[Bool].Default: true. Use it to determine if it is a required field.
                                                required: true, // Optional.[Bool].Default: true. Use it to determine if it is a required field.
                                                maxlength: "1000",
                                                //length: "1000",
                                                //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                                                reg: expresionesRegulares.stringSinCaracteresEspeciales,
                                                msgOnError: "Se permite el ingreso de letras y números exclusivamente"
                                            }}
                                        />
                                    </Col>
                                </React.Fragment>
                            }

                        </Row>


                    </React.Fragment>
                }
            </CardBody>
        </Card>
    )
}

export default Recargos;